export const RECORD_WITH_PLAYBACK_USER_SETTING_KEY = 'recordWithPlayback';
export const SUPPRESS_SVG_CROP_WARNING = 'suppressSvgCropWarning';
